// extracted by mini-css-extract-plugin
export var button = "_jh-0";
export var donut = "_jh-1";
export var donutFill = "_jh-3";
export var donutTrack = "_jh-2";